module.exports = __webpack_public_path__ + "images/fa00f70bd5014ef1ff1e4b514d2dd2f0.webp";